export default __webpack_public_path__ + "static/media/template15.556ccc12.jpg";